import MouseManager from './mouse-manager';

const Mouse = new MouseManager();

export { Mouse };
